import { useState } from "react";
import { contact } from "../lib/api";
import { Check } from "./icons";

/** Footer contact-us form: subject, message, and a reply-to email. */
export function ContactForm() {
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await contact.send(email, subject, message);
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Something went wrong");
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <div className="success" data-testid="contact-success" style={{ fontSize: 15 }}>
        <Check /> Thanks — we'll get back to you at that email.
      </div>
    );
  }

  return (
    <form className="contact-form" onSubmit={submit} data-testid="contact-form">
      {error && <div className="error-box" data-testid="contact-error">{error}</div>}
      <div className="contact-row">
        <input
          className="input" type="email" required placeholder="Your email"
          aria-label="Your email" value={email} onChange={(e) => setEmail(e.target.value)}
          data-testid="contact-email"
        />
        <input
          className="input" required placeholder="Subject"
          aria-label="Subject" value={subject} onChange={(e) => setSubject(e.target.value)}
          data-testid="contact-subject"
        />
      </div>
      <textarea
        className="input" required rows={3} placeholder="How can we help?"
        aria-label="Message" value={message} onChange={(e) => setMessage(e.target.value)}
        data-testid="contact-message"
      />
      <button className="btn btn-primary btn-sm" disabled={busy} data-testid="contact-submit">
        {busy ? "Sending…" : "Send message"}
      </button>
    </form>
  );
}
